import { Heading, Para, Stack } from 'ui-components';
import CutNowButton from '../CutNowButton';

type Props = {
  expiresAt: string;
};

export default function CouponExpired({ expiresAt }: Props) {
  const expirationDate = new Date(expiresAt).toLocaleDateString();

  return (
    <Stack gap={6} className="items-center text-center text-pretty">
      <Heading variant="h2">Coupon Expired</Heading>

      <Stack gap={2}>
        <Para>
          Dieser Gutscheincode ist am <strong>{expirationDate}</strong> abgelaufen.
        </Para>

        <Para>
          Du kannst aber auf unserer Website jederzeit die aktuelle Wartezeit sehen und Deinen
          nächsten DRYCUT unkompliziert buchen.
        </Para>
      </Stack>

      <CutNowButton />
    </Stack>
  );
}
